module.exports = __webpack_public_path__ + "img/1591779685230830jvb.5ad8fc66.jpg";